const list = {
  // =================================================================================================================
  components () {
    return [
      {'component': 'search-start-end', "label": '작성일', "value":'date', "query":{'ss':'startDate', 'ee':'endDate'}, "options":{}},
      {'component': 'search-column-keyword',
        "label": '검색조건',
        "value":'column',
        "query":{'ck_t':'head', 'ck_k':'keyword'},
        "options": { hiddenList: ['작성일', '작성년도']}
      },
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let dateTarget = "created_at";
    let dateBegin = `${new Date().getFullYear()}-01-01`;
    let dateEnd = `${new Date().getFullYear()}-12-31`;
    if (search.year) {
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
    }
    //  검색일
    if (search.date) {
      if (search.date.startDate) dateBegin = search.date.startDate;
      if (search.date.endDate) dateEnd = search.date.endDate;
    }
    conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})


    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "작성년도",
        "key": "body.stdInfo.date"
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "안전보건총괄책임자",
        "key": "body.inputD_1"
      },
      {
        "name": "책임자 소속명",
        "key": "body.inputD_2"
      },
      {
        "name": "책임자 직위 및 직책",
        "key": "body.inputD_3"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.section"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "작성일",
        "key": "created_at"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.date? func.getContent(value).stdInfo.date.split('-')[0] : '' // 작성년도

      case 1: return func.getContent(value).stdInfo.field_name // 사업장명
      case 2: return func.getContent(value).inputD_1
      case 3: return func.getContent(value).inputD_2
      case 4: return func.getContent(value).inputD_3
      case 5: return func.getContent(value).stdInfo.section // 부서명
      case 6: return func.getContent(value).stdInfo.writer_name // 작성자
      case 7: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
